import { requester } from '@space-shell/config/request'

import { ExternalLinkEndpoints } from './constants'
import type { ExternalLinkPayload, ExternalLink } from './types'

class ExternalLinkService {
  static async add(slug: string, payload: ExternalLinkPayload) {
    const { data } = await requester.post(ExternalLinkEndpoints.add(slug), payload)

    return data
  }

  static async list(slug: string) {
    const { data } = await requester.get<ExternalLink[]>(ExternalLinkEndpoints.list(slug))

    return data
  }

  static async update(id: string, slug: string, payload: ExternalLinkPayload) {
    const { data } = await requester.put(ExternalLinkEndpoints.update(id, slug), payload)

    return data
  }

  static async remove(id: string, slug: string) {
    const { data } = await requester.delete(ExternalLinkEndpoints.remove(id, slug))

    return data
  }
}

export default ExternalLinkService
